import React from 'react';

function SwitchInput({ item, switchHandler, index }) {
  return (
    <div className="px-2">
      <div className="custom-control custom-switch ">
        <input
          type="checkbox"
          className="custom-control-input"
          id={`${item?._id || item?.label}_${index}`}
          checked={item?.rightsArray[0]?.section?.switchStatus}
          onClick={(e) => {
            switchHandler(item, e.target.checked);
          }}
        />
        <label className="custom-control-label" htmlFor={`${item?._id || item?.label}_${index}`}>
          <p className="m-0 f-18">
            {item?.rightsArray?.[0]?.section?.label === 'Supplier Overview' ? 'Partner Overview' : item?.rightsArray?.[0]?.section?.label}
          </p>
        </label>
      </div>
    </div>
  );
}

export default SwitchInput;
